import type { Brief } from './domain';
import { getActionSpec } from './catalog';
import { briefForPerson, type PersonProfile } from './people';
import type { Decision } from './storage';

/** A shared pattern is a previous direction, never evidence of an identical SKU. */
export function previousChoices(current: Decision, history: Decision[], person?: PersonProfile) {
  if (!current.brief.recipientKey) return [];
  return history
    .filter(item => item.id !== current.id && item.brief.recipientKey === current.brief.recipientKey && item.selectedPatternId)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    .map(item => {
      const selected = item.results.find(result => result.id === item.selectedPatternId);
      const gift = person && person.id === current.brief.recipientKey
        ? person.gifts.find(record => record.direction === 'given' && record.decisionId === item.id)
        : undefined;
      return {
        id: item.id,
        patternId: item.selectedPatternId!,
        direction: selected?.name ?? '과거에 고른 방향',
        title: gift?.title ?? getActionSpec(item.selectedActionId)?.title ?? selected?.name ?? '과거 선택',
        date: gift?.date ?? item.createdAt.slice(0, 10),
        actualGift: Boolean(gift),
        reaction: gift?.reaction ?? [item.outcome?.d7, item.outcome?.d30].filter(Boolean).join(' · '),
      };
    });
}

/** A new occasion needs current budget/time confirmation, no old receipt or outcome. */
export function reuseDecisionBrief(previous: Decision, person?: PersonProfile): Partial<Brief> {
  const previousConditions: Partial<Brief> = {
    ...previous.brief,
    occasion: undefined,
    budget: undefined,
    budgetMax: undefined,
    urgency: undefined,
    interests: [...previous.brief.interests],
    avoids: [...previous.brief.avoids],
    owned: [...(previous.brief.owned ?? [])],
  };
  return person ? briefForPerson(person, previousConditions) : previousConditions;
}
/** A likely repeat is only a prompt to check; it is never a SKU identity claim. */
export function repeatedGift(patternId:string,patternName:string,person:PersonProfile|undefined,history:Decision[],now=new Date()){
 if(!person)return undefined;const earliest=new Date(now);earliest.setFullYear(earliest.getFullYear()-3);earliest.setHours(0,0,0,0);
 const compact=(value:string)=>value.normalize('NFKC').replace(/[\s\p{P}\p{S}]+/gu,'').toLocaleLowerCase();
 const words=(value:string)=>new Set(value.normalize('NFKC').toLocaleLowerCase().split(/[^\p{L}\p{N}]+/u).filter(word=>word.length>=2));
 const target=compact(patternName),targetWords=words(patternName);
 return person.gifts.filter(gift=>gift.direction==='given').filter(gift=>{const date=new Date(`${gift.date}T00:00:00`);return date>=earliest&&date<=now}).sort((a,b)=>b.date.localeCompare(a.date)).find(gift=>{
  const linked=gift.decisionId?history.find(decision=>decision.id===gift.decisionId&&decision.personId===person.id):undefined;
  if(linked?.selectedPatternId===patternId)return true;
  const title=compact(gift.title);if(title.length>=2&&target.length>=2&&(target.includes(title)||title.includes(target)))return true;
  return [...words(gift.title)].filter(word=>targetWords.has(word)).length>=2;
 });
}
